import MerchantListView from '@/views/Merchants/MerchantListView/MerchantListView.vue'
import MerchantDetailView from '@/views/Merchants/MerchantDetailView/MerchantDetailView.vue'
import TransactionSearchView from '@/views/Reports//TransactionSearchView.vue'
import TransactionReportView from '@/views/Reports//TransactionReportView.vue'
import SweepReportView from '@/views/Reports/SweepReportView.vue'

export default [
  { path: '/merchants', component: MerchantListView, name: 'MerchantList' },
  {
    path: '/merchants/:merchantID',
    component: MerchantDetailView,
    name: 'MerchantDetail'
  },
  {
    path: '/transaction-search',
    component: TransactionSearchView,
    name: 'TransactionSearch'
  },
  {
    path: '/transaction-report',
    component: TransactionReportView,
    name: 'TransactionReport'
  },
  { path: '/sweep-report', component: SweepReportView, name: 'SweepReport' }
]
